import React from 'react';
import {Link} from 'react-router-dom';
import { assetPath, services } from '../../data/companyData';

export default class ServiceThree extends React.Component {
    render(){
        let publicUrl = process.env.PUBLIC_URL+'/'
        return (
            <>
                <section className="services-three">
                    <div className="shape1"><img src={publicUrl+"assets/images/shapes/services-v3-shape1.png"} alt="#" /></div>
                    <div className="shape2 rotate-me"><img src={publicUrl+"assets/images/update1.0/services-v3-shape2.png"} alt="#" /></div>
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-12">
                                <div className="services-three__top">
                                    <div className="sec-title">
                                        <div className="sec-title__tagline">
                                            <h6>COMPANY SERVICES </h6> <span className="right"></span>
                                        </div>
                                        <h2 className="sec-title__title">Interior trim and remodeling <br /> services</h2>
                                    </div>
                                    <div className="text-box">
                                        <p>From custom cabinetry to full remodeling, we bring practical planning, clean execution, and quality finishes to every space.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            {services.slice(0, 4).map((service, index) => (
                                <div className="col-xl-3 col-lg-6 col-md-6" key={service.slug}>
                                    <div className={`services-three__single ${index === 0 ? "active" : ""}`}>
                                        <div className="services-three__single__bg" style={{backgroundImage: `url(${assetPath(service.image)})`}}></div>
                                        <div className="services-three__single-icon">
                                            <span className={service.icon}></span>
                                        </div>
                                        <h3><Link to={process.env.PUBLIC_URL + service.path}>{service.title}</Link></h3>
                                        <p>{service.summary}</p>
                                        <div className="btn-box">
                                            <Link to={process.env.PUBLIC_URL + service.path}><span className="icon-right-arrow"></span></Link>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
            </>
        )
    }
}
